module.exports = __webpack_public_path__ + "img/apisfirst.fc1d489d.png";